<esn-background-glow class="shell">
  <div class="shell__row">
    <esn-sidebar
      [userName]="userName()"
      [accountInteractive]="true"
      themeSwitchLabel="Light theme"
      [lightTheme]="!theme.darkMode()"
      (lightThemeChange)="setLightTheme($event)"
      (accountClicked)="openAccountSettings()"
    >
      <div class="shell__nav" data-tour="nav">
        @for (item of mainNav; track item.route) {
          <a [routerLink]="item.route" [attr.aria-current]="isActive(item.route) ? 'page' : null">
            <esn-nav-item [icon]="item.icon" [active]="isActive(item.route)">{{ item.label }}</esn-nav-item>
          </a>
        }

        @if (adminNav().length) {
          <esn-sidebar-section label="Administration">
            @for (item of adminNav(); track item.route) {
              <a [routerLink]="item.route" [attr.aria-current]="isActive(item.route) ? 'page' : null">
                <esn-nav-item [icon]="item.icon" [active]="isActive(item.route)">{{ item.label }}</esn-nav-item>
              </a>
            }
          </esn-sidebar-section>
        }
      </div>

      <!-- Which company this BFF is bound to (anti-mix-up in local CLI dev). -->
      @if (company; as c) {
        <p esn-sidebar-footer class="shell__company" [title]="'Company organizationId: ' + c.organizationId">
          ● {{ c.resourceId }}
        </p>
      }
      <a esn-sidebar-footer data-tour="help-center" routerLink="/help" [attr.aria-current]="isActive('/help') ? 'page' : null">
        <esn-nav-item icon="info" size="sm" [active]="isActive('/help')">Help Center</esn-nav-item>
      </a>
      <button esn-sidebar-footer type="button" class="shell__link" (click)="tour.start()">
        <esn-nav-item icon="help" size="sm">Take the tour</esn-nav-item>
      </button>
      <button esn-sidebar-footer type="button" class="shell__link" (click)="auth.logout()">
        <esn-nav-item icon="close" size="sm">Sign out</esn-nav-item>
      </button>
    </esn-sidebar>

    <main class="shell__main">
      <router-outlet />
    </main>
  </div>
  <esn-toast-outlet />
  <es-portal-tour />
</esn-background-glow>
